export enum testIds {
	BUTTON = 'buttonTest',
	BUTTON_LOADER = 'buttonLoaderTest',
}
